<template>
  <el-row class="lad-country--weather" type="flex" :gutter="20">
    <el-col v-if="hasTemperatures" :md="md" :xs="xs">
      <el-card shadow="never">
        <h3>{{ $t(`${base}.temperatures`, { country: country.name }) }}</h3>
        <LazyLoading
          :key="`temperatures`"
          :loaded="lazy.temperatures"
          @loaded="(e) => (lazy.temperatures = e)"
        >
          <VueApexCharts
            v-if="lazy.temperatures"
            height="260"
            :options="temperatures.options"
            :series="temperatures.series"
          ></VueApexCharts>
        </LazyLoading>
      </el-card>
    </el-col>

    <el-col v-if="hasRainfalls" :md="md" :xs="xs">
      <el-card shadow="never">
        <h3>{{ $t(`${base}.rainfalls`, { country: country.name }) }}</h3>
        <LazyLoading
          :key="`rainfalls`"
          :loaded="lazy.rainfalls"
          @loaded="(e) => (lazy.rainfalls = e)"
        >
          <VueApexCharts
            v-if="lazy.rainfalls"
            height="260"
            :options="rainfalls.options"
            :series="rainfalls.series"
          ></VueApexCharts>
        </LazyLoading>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LadCountryWeatherInformation',
  components: {
    VueApexCharts: () =>
      import(/* webpackChunkName: "vue-apexcharts" */ 'vue-apexcharts'),
  },
  props: {
    md: { type: Number, default: 12 },
    xs: { type: Number, default: 24 },
  },
  data() {
    return {
      base: 'components.country',
      lazy: {
        temperatures: false,
        rainfalls: false,
      },
    }
  },
  computed: {
    ...mapState('country', {
      country: (state) => ({ name: state.header.name }),
      temperatures(state) {
        const categories = []
        const series = []

        if (state.temperatures.length) {
          state.temperatures
            .slice(Math.max(state.temperatures.length - 12, 0))
            .forEach((e) => {
              const month = this.$dayjs()
                .month(e.month - 1)
                .format('MMM')

              categories.push(month)
              series.push(e.celsius_degrees)
            })
        }

        return {
          options: {
            chart: {
              type: 'area',
              toolbar: {
                show: true,
                tools: {
                  download: false,
                  selection: false,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: false,
                },
              },
            },
            xaxis: {
              categories,
            },
            stroke: {
              curve: 'smooth',
              width: 2,
            },
            dataLabels: {
              enabled: false,
            },
            colors: ['#409EFF'],
            fill: {
              type: 'gradient',
              gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.7,
                opacityTo: 0.9,
                stops: [0, 100],
              },
            },
          },
          series: [
            {
              name: this.$t(`${this.base}.temperatures`, {
                country: this.country.name,
              }),
              data: series,
            },
          ],
        }
      },
      rainfalls(state) {
        const categories = []
        const series = []

        if (state.rainfalls.length) {
          state.rainfalls
            .slice(Math.max(state.rainfalls.length - 12, 0))
            .forEach((e) => {
              const month = this.$dayjs()
                .month(e.month - 1)
                .format('MMM')

              categories.push(month)
              series.push(e.millimeters.toFixed(2))
            })
        }

        return {
          options: {
            chart: {
              type: 'area',
              toolbar: {
                show: true,
                tools: {
                  download: false,
                  selection: false,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: false,
                },
              },
            },
            xaxis: {
              categories,
            },
            stroke: {
              curve: 'smooth',
              width: 2,
            },
            dataLabels: {
              enabled: false,
            },
            colors: ['#0A960C'],
            fill: {
              type: 'gradient',
              gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.7,
                opacityTo: 0.9,
                stops: [0, 100],
              },
            },
          },
          series: [
            {
              name: this.$t(`${this.base}.rainfalls`, {
                country: this.country.name,
              }),
              data: series,
            },
          ],
        }
      },
    }),
    hasRainfalls() {
      return this.rainfalls.series.length > 0
    },
    hasTemperatures() {
      return this.temperatures.series.length > 0
    },
  },
}
</script>

<style lang="scss">
.lad-country--weather {
  /** */
}
</style>
